import request from '@teetsh/app/src/utils/request';
import { Plan } from '@teetsh/app/src/types/plan';
import { useQuery } from '@tanstack/react-query';

export const PLAN_KEY = 'plans';

function getPlans(locale?: string) {
  const params = new URLSearchParams();
  if (locale) {
    params.append('lng', locale);
  }
  return request('/plans', {
    method: 'GET',
    params,
  }).then<Plan[]>(res => res);
}

export function useGetPlans(locale?: string) {
  return useQuery({
    queryKey: [PLAN_KEY, locale],
    queryFn: () => getPlans(locale),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24,
  });
}
